import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { getDevice } from '@utils';
import Icon from '../../base_svg-icon/component';
import Link from '../../base_link/component';
import { ProductImage } from 'audamatic-ui';
import { Product } from '@utils/product';

import './styles/styles.scss';
class BannerHero extends Component {
  constructor(props) {
    super(props);
    this.pushGoogleTags = this.pushGoogleTags.bind(this);
  }

  get title() {
    return this.props.title || null;
  }

  get subtitle() {
    return this.props.subtitle || null;
  }

  get images() {
    return {
      leftImage: this.props.leftImage || null,
      rightImage: this.props.rightImage || null,
      backgroundImage: this.props.backgroundImage || null,
    };
  }

  get url() {
    return this.props.url || '';
  }

  get backgroundColor() {
    return this.props.colorCode || '';
  }

  pushGoogleTags() {
    this.props.googleTagMethods()
      .pushPromotionGoogleTag(this.props);
  }

  get booklist() {
    const { isMobile, isTablet } = getDevice();
    const maxItems = isMobile || isTablet ? 3 : 4;

    const { products = [] } = this.props;
    return products.slice(0, maxItems).map((_product, index) => {
      const product = new Product(_product);
      return (
        <div key={index} className="cover-wrap">
          <ProductImage product={product} />
        </div>
      );
    });
  }

  renderSmallScreenContent() {
    if (!!this.title  || !!this.subtitle) {
      return (
        <div className="mobile-hero-body visible-xs">
          <h1 className="mobile-title">{this.title}</h1>
          <div className="mobile-subtitle">{this.subtitle}</div>
          { this.url &&
          <Icon
            className="arrow-button"
            name="ico-arrow-circle-right"
            size={150} />
          }
        </div>
      );
    }
  }


  renderLargeScreenContent() {
    const { images } = this;
    const { isTablet } = getDevice();
    return (
      <Fragment>
        <div className={`banner-hero-media ${isTablet ? 'tablet' : ''}`}>
          <div>
            { !!images && !!images.leftImage &&
            <img className="banner-hero-media-left" src={images.leftImage} alt={this.title}/>
            }
            { !!images && !!images.rightImage &&
            <img className="banner-hero-media-right" src={images.rightImage} alt={this.title}/>
            }
            {/* <Image className="banner-hero-media-right" src={this.images.rightImage} lazy="false"/>*/}
            {/* <Image className="banner-hero-media-left" src={this.images.leftImage} lazy="false"/>*/}
          </div>
        </div>
        <div className="banner-wrap-content">
          {/* Desktop versie*/}
          <div className="banner-hero-body hidden-xs">
            <h1 className="banner-hero-title">
              {!!this.title &&
          <span><span>{this.title}</span></span>
              }
            </h1>
            <div className="banner-hero-subtitle ">
              {!!this.subtitle &&
          <span>{this.subtitle}</span>
              }
            </div>
          </div>
          <div className="products-wrap">
            <div className="booklist-images">
              {this.booklist}
            </div>
          </div>

        </div>

        { this.url &&
          <Icon
            className="arrow-button hidden-xs"
            name="ico-arrow-circle-right"
            size={150}/>
        }
      </Fragment>
    );
  }


  render() {
    const backgroundStyle = { backgroundColor: this.backgroundColor };
    if (this.images.backgroundImage) {
      backgroundStyle.backgroundImage = `url(${this.images.backgroundImage})`;
    }
    if (this.url) {
      return (
        <Link to={this.url} className="banner banner-hero" onClick={this.pushGoogleTags}>
          <div className={'bg-container'} style={backgroundStyle}>
            {this.renderLargeScreenContent()}
            {this.renderSmallScreenContent()}
          </div>
        </Link>
      );
    }
    return (
      <div className="banner banner-hero">
        <div className={'bg-container'} style={backgroundStyle}>
          {this.renderLargeScreenContent()}
          {this.renderSmallScreenContent()}
        </div>
      </div>
    );
  }
}


BannerHero.propTypes = {
  /**
   * The title which will be shown in black in the banner
   */
  title: PropTypes.string,
  /**
   * The subtitle which will be shown in green in the banner
   */
  subtitle: PropTypes.string,
  /**
   * The url the banner needs to point to
   */
  url: PropTypes.string,
  /**
   * Color code for the background
   */
  colorCode: PropTypes.string,
  /**
   * Image placed in the background
   */
  backgroundImage: PropTypes.string,
  /**
   * Image place on the left side of the banner
   */
  leftImage: PropTypes.string,
  /**
   * Image place on the right side of the banner
   */
  rightImage: PropTypes.string,
  products: PropTypes.array,
  /**
   * An additional link that refers to another page
   */
  link: PropTypes.shape({
    /**
     * Text of the additional link
     */
    textContent: PropTypes.string,
    /**
     * Url of the additional link
     */
    url: PropTypes.string,
  }),
  /**
   * Function that returns an object with
   * Google Tags methods
   */
  googleTagMethods: PropTypes.func,
};


export default BannerHero;
